import { ConsoleComponent } from './admin/console/console.component';
import { AppSelectionModalComponent } from './auth/register/app-selection-modal/app-selection-modal.component';
import { RegisterComponent } from './auth/register/register.component';
import { PaypalButtonComponent } from './auth/register/paypal-button/paypal-button.component';
import { TokenInterceptor } from './services/token.interceptor';
import { EditSubComponent } from './admin/subscription/edit-sub/edit-sub.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VexModule } from '../@vex/vex.module';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {MatIcon, MatIconModule} from "@angular/material/icon";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SubscriptionNewComponent } from './admin/subscription/new-sub/subscription-new.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PromotionNewComponent } from './admin/promotion/promotion-new/promotion-new.component';
import { ProgramNewComponent } from './admin/program/program-new/program-new.component';
import { NewExerciseComponent } from './admin/exercise/new-exercise/new-exercise.component';
import { MatSliderModule } from '@angular/material/slider';
import { PromotionsComponent } from './admin/promotion/promotions.component';
import { PromotionsModule } from './admin/promotion/promotions.module';
import { ExerciseComponent } from './admin/exercise/exercise.component';
import { ExerciseModule } from './admin/exercise/exercise.module';
import { ProgramComponent } from './admin/program/program.component';
import { ProgramModule } from './admin/program/program.module';
import { EditExerciseComponent } from './admin/exercise/edit-exercise/edit-exercise.component';
import { WorkoutNewComponent } from './admin/workout/workout-new/workout-new.component';
import { WorkoutComponent } from './admin/workout/workout.component';
import { WorkoutModule } from './admin/workout/workout.module';
import { ProgramEditComponent } from './admin/program/program-edit/program-edit.component';
import { PromotionEditComponent } from './admin/promotion/promotion-edit/promotion-edit.component';
import { DialogConfirmComponent } from './admin/dialog-confirm/dialog-confirm.component';
import { UserEditComponent } from './admin/user/user-edit/user-edit.component';
import { WorkoutEditComponent } from './admin/workout/workout-edit/workout-edit.component';
import {MatNativeDateModule} from "@angular/material/core";
import { QuillModule } from 'ngx-quill';
import {MatGridListModule} from "@angular/material/grid-list";
import {MatChipsModule} from "@angular/material/chips";
import {MatCardModule} from "@angular/material/card";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {MatExpansionModule} from '@angular/material/expansion';
import { HomeComponent } from './main/home/home.component';
import { NutritionComponent } from './admin/nutrition/nutrition.component';
import { NutritionDetailComponent } from './admin/nutrition/nutrition-detail/nutrition-detail.component';
import { AdministratorComponent } from './admin/administrator/administrator.component';
import { AdminProfileComponent } from './admin/administrator/admin-profile/admin-profile.component';
import { AdminNotificationsComponent } from './admin/admin-notifications/admin-notifications.component';
import { NewNotificationComponent } from './admin/admin-notifications/new-notification/new-notification.component';
import { ChallengeComponent } from './admin/challenge/challenge.component';
import { EditChallengeComponent } from './admin/challenge/edit-challenge/edit-challenge.component';
import { NewChallengeComponent } from './admin/challenge/new-challenge/new-challenge.component';
import { EditNotificationComponent } from './admin/admin-notifications/edit-notification/edit-notification.component';
import { ResetPswComponent } from './auth/reset-psw/reset-psw.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CustomerListComponent } from './nutritionist/customer-list/customer-list.component';
import { NutriComponent } from './nutritionist/nutri/nutri.component';
import { NutriProfileComponent } from './nutritionist/nutri/nutri-profile/nutri-profile.component';
import { SecurePipePipe } from './services/secure-pipe.pipe';
import { UpgradePlanComponent } from './auth/upgrade-plan/upgrade-plan.component';
import { AdminResetPasswordComponent } from './admin/administrator/admin-reset-password/admin-reset-password.component';
import { NutriResetPasswordComponent } from './nutritionist/nutri/nutri-reset-password/nutri-reset-password.component';
import { PaymentRejectedComponent } from './auth/payment-rejected/payment-rejected.component';
import { MatSortModule } from '@angular/material/sort';
import { CloseConfirmComponent } from './admin/close-confirm/close-confirm.component';
import { MatDividerModule } from '@angular/material/divider';
import { ReportsComponent } from './admin/reports/reports.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TimeChallengeComponent } from './admin/challenge/time-challenge/time-challenge.component';
import { RegisterConfirmComponent } from './auth/register-confirm/register-confirm.component';
import { EmailAlreadyModalComponent } from './auth/register/email-already-modal/email-already-modal.component';
import { ErrorUpgradeModalComponent } from './auth/upgrade-plan/error-upgrade-modal/error-upgrade-modal.component';
import { ConfirmUpgradeModalComponent } from './auth/upgrade-plan/confirm-upgrade-modal/confirm-upgrade-modal.component';
import { RegSubInfoComponent } from './auth/register/reg-sub-info/reg-sub-info.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { CategorieComponent } from './admin/categorie/categorie.component';
import { MatTreeModule } from '@angular/material/tree';
import { NewCategoryComponent } from './admin/categorie/new-category/new-category.component';
import { EditCategoryComponent } from './admin/categorie/edit-category/edit-category.component';
import { NewVideoComponent } from './admin/categorie/new-video/new-video.component';
import { EditVideoComponent } from './admin/categorie/edit-video/edit-video.component';
import { AssignOndemandComponent } from './admin/assign-ondemand/assign-ondemand.component';
import { RenewPlanComponent } from './auth/renew-plan/renew-plan.component';
import { ConfirmRenewModalComponent } from './auth/renew-plan/confirm-renew-modal/confirm-renew-modal.component';
import { RecipesComponent } from './admin/recipes/recipes.component';
import { NewRecipeComponent } from './admin/recipes/new-recipe/new-recipe.component';
import { EditRecipeComponent } from './admin/recipes/edit-recipe/edit-recipe.component';
import { ComposeDietComponent } from './admin/nutrition/nutrition-detail/compose-diet/compose-diet.component';
import { NewWeekTimeChallengeComponent } from './admin/challenge/time-challenge/new-week-time-challenge/new-week-time-challenge.component';
import { NewSubTimeChallengeComponent } from './admin/challenge/time-challenge/new-sub-time-challenge/new-sub-time-challenge.component';
import { EditSubTimeChallengeComponent } from './admin/challenge/time-challenge/edit-sub-time-challenge/edit-sub-time-challenge.component';
import { EditWeekTimeChallengeComponent } from './admin/challenge/time-challenge/edit-week-time-challenge/edit-week-time-challenge.component';
import { NewTimeChallengeComponent } from './admin/challenge/time-challenge/new-time-challenge/new-time-challenge.component';
import { BannerAreaComponent } from './admin/banner-area/banner-area.component';
import { EditBannerAreaComponent } from './admin/banner-area/edit-banner-area/edit-banner-area.component';
import { NewBannerAreaComponent } from './admin/banner-area/new-banner-area/new-banner-area.component';
import { ThropiesComponent } from './admin/thropies/thropies.component';
import { NewThropyComponent } from './admin/thropies/new-thropy/new-thropy.component';
import { EditThropyComponent } from './admin/thropies/edit-thropy/edit-thropy.component';
import { StreamEventComponent } from './admin/stream-event/stream-event.component';
import { NewStreamEventComponent } from './admin/stream-event/new-stream-event/new-stream-event.component';
import { EditStreamEventComponent } from './admin/stream-event/edit-stream-event/edit-stream-event.component';
import { RegisterConfirmMobileComponent } from './auth/register-confirm-mobile/register-confirm-mobile.component';
import { PopupModalComponent } from './main/shared/popup-modal/popup-modal.component';
import { SurveyAdminComponent } from './admin/nutrition/nutrition-detail/survey-admin/survey-admin.component';
import { register } from 'swiper/element/bundle';
import { ChangeWeekComponent } from './main/home/change-week/change-week.component';
import { WorkoutProgramsComponent } from './main/home/workout-programs/workout-programs.component';
import { WorkoutProgramDetailComponent } from './main/home/workout-programs/workout-program-detail/workout-program-detail.component';
import { WorkoutDetailComponent } from './main/workout/workout-detail/workout-detail.component';
import { ExerciseDetailComponent } from './main/workout/workout-detail/exercise-detail/exercise-detail.component';
import { SwapExerciseModalComponent } from './main/workout/workout-detail/swap-exercise-modal/swap-exercise-modal.component';
import { WorkoutExecutionComponent } from './main/workout/workout-execution/workout-execution.component';
import { LeaveWorkoutPopupComponent } from './main/workout/workout-execution/leave-workout-popup/leave-workout-popup.component';
import { RegisterWeightComponent } from './main/workout/workout-execution/register-weight/register-weight.component';
import { WorkoutCompletedComponent } from './main/workout/workout-execution/workout-completed/workout-completed.component';
import { WorkoutPhaseComponent } from './main/workout/workout-execution/workout-phase/workout-phase.component';
import { WorkoutRestComponent } from './main/workout/workout-execution/workout-rest/workout-rest.component';
import { InfoComponent } from './main/info/info.component';
import { FacebookComponent } from './main/facebook/facebook.component';
import { OnDemandComponent } from './main/on-demand/on-demand.component';
import { OnDemandCategoryComponent } from './main/on-demand/on-demand-category/on-demand-category.component';
import { OnDemandVideoComponent } from './main/on-demand/on-demand-category/on-demand-video/on-demand-video.component';
import { TimeChallengeVideoComponent } from './main/on-demand/time-challenge-user/time-challenge-video/time-challenge-video.component';
import { TimeChallengeUserComponent } from './main/on-demand/time-challenge-user/time-challenge-user.component';
import { NotificationsComponent } from './main/notifications/notifications.component';
import { UserProfileComponent } from './main/user/user-profile.component';
import { SubComponent } from './main/user/sub/sub.component';
import { ResetPasswordComponent } from './main/user/reset-password/reset-password.component';
import { ProfileComponent } from './main/user/profile/profile.component';
import { ChangeSubstatusModalComponent } from './main/user/sub/change-substatus-modal/change-substatus-modal.component';
import { MsgContactSupportComponent } from './main/user/sub/msg-contact-support/msg-contact-support.component';
import { PayModalComponent } from './main/user/sub/pay-modal/pay-modal.component';
import { TmpMsgContactComponent } from './main/user/sub/tmp-msg-contact/tmp-msg-contact.component';
import { DiaryComponent } from './main/diary/diary.component';
import { ExerciseTrackerComponent } from './main/diary/exercise-tracker/exercise-tracker.component';
import { FavoriteWorkoutsComponent } from './main/diary/favorite-workouts/favorite-workouts.component';
import { WorkoutHistoryComponent } from './main/diary/workout-history/workout-history.component';
import { ThropiesUserComponent } from './main/diary/thropies-user/thropies-user.component';
import { TrophyDetailComponent } from './main/diary/thropies-user/trophy-detail/trophy-detail.component';
import { ExerciseTrackerDetailComponent } from './main/diary/exercise-tracker/exercise-tracker-detail/exercise-tracker-detail.component';
import { WorkoutDetailFavoriteComponent } from './main/diary/favorite-workouts/workout-detail-favorite/workout-detail-favorite.component';
import { WorkoutExecutionFavoriteComponent } from './main/diary/favorite-workouts/workout-execution-favorite/workout-execution-favorite.component';
import { LiveStreamingComponent } from './main/live-streaming/live-streaming.component';
import { NutritionUserComponent } from './main/nutrition-user/nutrition-user.component';
import { CompileSurveyComponent } from './main/nutrition-user/compile-survey/compile-survey.component';
import { MealPlanComponent } from './main/nutrition-user/meal-plan/meal-plan.component';
import { MealDisclaimerComponent } from './main/nutrition-user/meal-plan/meal-disclaimer/meal-disclaimer.component';
import { MealInfoComponent } from './main/nutrition-user/meal-plan/meal-info/meal-info.component';
import { RecipeInfoComponent } from './main/nutrition-user/meal-plan/recipe-info/recipe-info.component';
import { MeasurementsComponent } from './main/nutrition-user/meal-plan/meal-info/measurements/measurements.component';
import { SupportComponent } from './main/support/support.component';
import { QuizSelectProgramComponent } from './auth/login/quiz-select-program/quiz-select-program.component';
import { FullViewDietComponent } from './admin/nutrition/nutrition-detail/compose-diet/full-view-diet/full-view-diet.component';
import { WeightHistoryComponent } from './main/workout/workout-execution/weight-history/weight-history.component';
import { AddonsComponent } from './admin/addons/addons.component';
import { AddonDetailComponent } from './admin/addons/addon-detail/addon-detail.component';
import { UserAddonsComponent } from './main/user-addons/user-addons.component';
import { UserAddonDetailComponent } from './main/user-addons/user-addon-detail/user-addon-detail.component';
import { AddonPurchaseHistoryComponent } from './main/addon-purchase-history/addon-purchase-history.component';
import { AddonPurchaseHistoryDetailComponent } from './main/addon-purchase-history/addon-purchase-history-detail/addon-purchase-history-detail.component';
import { DownloadEbookComponent } from './auth/download-ebook/download-ebook.component';

register()

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader (http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, SubscriptionNewComponent, PromotionNewComponent, ProgramNewComponent, NewExerciseComponent, PromotionsComponent, ExerciseComponent, ProgramComponent, EditExerciseComponent, WorkoutNewComponent, WorkoutComponent, ProgramEditComponent, PromotionEditComponent, DialogConfirmComponent, UserEditComponent, WorkoutEditComponent, EditSubComponent, HomeComponent, NutritionComponent, NutritionDetailComponent, AdministratorComponent, AdminProfileComponent, AdminNotificationsComponent, NewNotificationComponent, ChallengeComponent, EditChallengeComponent, NewChallengeComponent, EditNotificationComponent, ResetPswComponent, CustomerListComponent, NutriComponent, NutriProfileComponent, SecurePipePipe, UpgradePlanComponent, AdminResetPasswordComponent, NutriResetPasswordComponent, PaymentRejectedComponent, PaypalButtonComponent, CloseConfirmComponent,RegisterComponent, AppSelectionModalComponent, ConsoleComponent, ReportsComponent, TimeChallengeComponent, RegisterConfirmComponent, EmailAlreadyModalComponent, ErrorUpgradeModalComponent, ConfirmUpgradeModalComponent, RegSubInfoComponent,CategorieComponent,NewCategoryComponent,EditCategoryComponent,NewVideoComponent,EditVideoComponent, AssignOndemandComponent, RenewPlanComponent, ConfirmRenewModalComponent, RecipesComponent, NewRecipeComponent, EditRecipeComponent, ComposeDietComponent, NewSubTimeChallengeComponent, NewWeekTimeChallengeComponent, EditSubTimeChallengeComponent, EditWeekTimeChallengeComponent, NewTimeChallengeComponent, BannerAreaComponent, EditBannerAreaComponent, NewBannerAreaComponent, ThropiesComponent, NewThropyComponent, EditThropyComponent, StreamEventComponent, NewStreamEventComponent, EditStreamEventComponent, RegisterConfirmMobileComponent, PopupModalComponent, SurveyAdminComponent, ChangeWeekComponent, WorkoutProgramsComponent, WorkoutProgramDetailComponent, WorkoutDetailComponent, ExerciseDetailComponent, SwapExerciseModalComponent, WorkoutExecutionComponent, LeaveWorkoutPopupComponent, RegisterWeightComponent, WorkoutCompletedComponent, WorkoutPhaseComponent, WorkoutRestComponent, InfoComponent, FacebookComponent, OnDemandComponent, OnDemandCategoryComponent, OnDemandVideoComponent, TimeChallengeVideoComponent, TimeChallengeUserComponent, NotificationsComponent, UserProfileComponent, SubComponent, ResetPasswordComponent, ProfileComponent, ChangeSubstatusModalComponent, MsgContactSupportComponent, PayModalComponent, TmpMsgContactComponent, DiaryComponent, ExerciseTrackerComponent, FavoriteWorkoutsComponent, WorkoutHistoryComponent, ThropiesUserComponent, TrophyDetailComponent, ExerciseTrackerDetailComponent, WorkoutDetailFavoriteComponent, WorkoutExecutionFavoriteComponent, LiveStreamingComponent, NutritionUserComponent, CompileSurveyComponent, MealPlanComponent, MealDisclaimerComponent, MealInfoComponent, RecipeInfoComponent, MeasurementsComponent, SupportComponent, QuizSelectProgramComponent, FullViewDietComponent, WeightHistoryComponent, AddonsComponent, AddonDetailComponent, UserAddonsComponent, UserAddonDetailComponent, AddonPurchaseHistoryComponent, AddonPurchaseHistoryDetailComponent, DownloadEbookComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],

          [{ header: 1 }, { header: 2 }],               // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],      // superscript/subscript
          [{ indent: '-1' }, { indent: '+1' }],          // outdent/indent
          [{ direction: 'rtl' }],                         // text direction

          [{ size: ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],

          [{ color: [] }, { background: [] }],          // dropdown with defaults from theme
          [{ align: [] }],

          ['clean'],                                         // remove formatting button

          ['link', 'image', 'video']                         // link and image, video
        ]
      }
    }),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient],

      }
  }),

    NgxMatSelectSearchModule,

    // Vex
    VexModule,
    CustomLayoutModule,
    MatSelectModule,
    MatIconModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatSliderModule,
    PromotionsModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    ExerciseModule,
    MatTabsModule,
    MatTooltipModule,
    ProgramModule,
    MatStepperModule,
    MatRadioModule,
    DragDropModule,
    WorkoutModule,
    MatDialogModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatGridListModule,
    MatChipsModule,
    MatCardModule,
    MatExpansionModule,
    MatSortModule,
    PdfViewerModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatTreeModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
